export default __webpack_public_path__ + "static/media/facility_02_4.d9d4487c.png";